module.exports = __webpack_public_path__ + "img/29.02b10da1.jpg";